export const GTAG_INITIALIZED = 'gtagInitialized';
